import React from "react";
import { useQuery } from "react-query";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";
import FansReportTable from "./FansReportTable";
import { ButtonWithIcon, Container } from "../../lib";
import { getAllAttendees } from "../../../../api/report/reportApi";
import BackBtn from "../../lib/BackBtn";

const FansReportList = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;
  const [queryString, setQueryString] = React.useState<{
    page: number | string;
    search: string;
    numberInPage: number | string;
  }>({
    page,
    search: "",
    numberInPage: 10,
  });

  const { data, isLoading, isError, refetch } = useQuery(
    ["fansList", queryString.page, queryString.numberInPage, queryString.search],
    () =>
      getAllAttendees(
        Number(queryString.page),
        Number(queryString.numberInPage),
        queryString.search
      )
  );


  const setQSandEnable = (values) => {
    setQueryString(values);
    refetch();
  };
  
  const setQS = (page) => {
    setSearchParams({ page: page.toString() });
    setQueryString((state) => ({
      ...state,
      page: page,
    }));
  };

  if (isLoading) return <div>در حال بارگذاری...</div>;
  if (isError) return <div>خطا در دریافت اطلاعات</div>;

  return (
    <Container className={"bg-white p-0 mt-10"}>
      <div className="d-flex align-items-center justify-content-between table-header">
        <div className="d-flex align-items-center gap-4">
          <h3>لیست هواداران</h3>
        </div>
        <BackBtn onClick={() => navigate(-1)} />
      </div>
      
      <div className={"d-flex align-items-center justify-content-between table-header"}>
        <div className={"d-flex align-items-center gap-4"}>          
          <SearchForm
            onSubmitCallback={(searchTerm) => {
              setQSandEnable({ ...queryString, search: searchTerm });
            }}
            searchTerm={queryString.search}
          />
        </div>
      </div>

      {data?.attendees && data.attendees.length > 0 ? (
        <FansReportTable
          queryString={queryString}
          setQueryString={setQS}
          data={data}
          refetch={refetch}
          numberInPage={Number(queryString.numberInPage)}
        />
      ) : (
        <p className={"p-2 m-2"}>هواداری یافت نشد</p>
      )}
    </Container>
  );
};

const SearchForm = ({ onSubmitCallback, searchTerm }) => {
  return (
    <Formik
      initialValues={{ searchTerm: searchTerm || "" }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);
        if (onSubmitCallback) {
          onSubmitCallback(values.searchTerm);
        }
      }}
    >
      {({ isSubmitting, handleChange, values }) => (
        <Form 
          className={"d-flex align-items-center gap-3"}
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <Field
            type="text"
            name="searchTerm"
            className="border rounded p-2 bg-white w-c-130 text-right"
            placeholder="جستجو"
            onChange={handleChange}
            value={values.searchTerm}
          />
          <ErrorMessage name="searchTerm" component="div" className="text-red-600" />
          <ButtonWithIcon
            btnText="جستجو"
            iconName="magnifier"
            type="submit"
            disabled={isSubmitting}
          />
        </Form>
      )}
    </Formik>
  );
};

export default FansReportList; 